<template>
  <div v-show="isvalid">
    <div>
      <!-- Chart and Summary area -->
    </div>
    <div>
      <!-- Table area -->
      <table class="at-table">
        <thead>
          <tr>
            <th rowspan="2" class="at-table-hdr">Staff Id</th>
            <th rowspan="2" class="at-table-hdr">Staff Name</th>
            <th
              :colspan="this.extravars.monthlen"
              class="at-h-mid at-table-hdr"
            >
              Attendance
            </th>
          </tr>
          <tr>
            <!-- <th colspan="2"></th> -->
            <th
              v-for="(daydata, index) in serverdata.headers"
              :key="index"
              :style="
                daydata.day === 'Sun' ? 'background: #e6e6fa; color: #222;' : ''
              "
              class="at at-date-hd"
            >
              {{ formatNumber(daydata.dayNo) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- <tr v-for="(staffdata, index) in serverdata.staffAttendance" :key="index"> -->
          <tr v-for="(staffdata, index) in this.staffattendance" :key="index">
            <td>{{ staffdata.staffid }}</td>
            <td>{{ staffdata.staffname }}</td>
            <!-- append day attendance -->
            <!-- <td v-for="(attnd, index) in staffdata.data" :key="index" class="at" :style="(attnd.day === 'Sun' ||attnd.is_holiday)? 'background: red; color: #fff; border: 0px;': ''"> -->
            <td
              v-for="(attnd, index) in staffdata.data"
              :key="index"
              class="at at-cell"
              :style="
                attnd.cellstyle === 'red'
                  ? 'background: #ff5a5a; color: #fff;'
                  : attnd.cellstyle === 'darkred'
                  ? 'background: #e6e6fa; color: #222;'
                  : attnd.cellstyle === 'yellow'
                  ? 'background: #ffc845; color: #222; '
                  : ''
              "
            >
              {{ attnd.status }}
            </td>
            <!-- end day attendance -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'monthlyReport',
  data: function () {
    return {
      isvalid: false,
      serverdata: {},
      extravars: { monthlen: 0 },
      staffattendance: [
        {
          staffid: '',
          staffname: '',
          data: [
            { date: '', status: '', day: '', isholiday: false, cellstyle: '' },
          ],
        },
      ],
    }
  },
  created: function () {
    // Add skeleton loading...
    let pvar = this.$route.params.month
    console.log('param', pvar)
    if (pvar != null) {
      this.isvalid = true
      let daterange = [
        moment(pvar).startOf('month').format('YYYY-MM-DD'),
        moment(pvar).endOf('month').format('YYYY-MM-DD'),
      ]
      this.$http
        .get(
          `/api/staff/attendance/report/monthly?start_date=${daterange[0]}&end_date=${daterange[1]}`
        )
        .then((data) => {
          var t = (this.serverdata = data.data.data)
          var rc = 0
          console.log(this.serverdata)
          this.extravars.monthlen = this.serverdata.headers.length
          this.staffattendance = this.serverdata.staffAttendance.map(function (
            d
          ) {
            let row = {
              staffid: d.system_staff_id,
              staffname: d.first_name + ' ' + d.last_name,
              data: t.headers.map(function (de) {
                let row = t.staffAttendance[rc].attendances.find(
                  ({ date }) => date === de.date
                )
                // let row = { date: de.date, status: t.staffAttendance[rc].attendances.find(({ date }) => date === de.date ) }
                if (row === undefined) {
                  row = { date: de.date, status: '-' }
                }
                // console.log(row.status)
                return Object.assign(row, {
                  status:
                    de.day === 'Sun' ? 'S' : de.is_holiday ? 'H' : row.status,
                  day: de.day,
                  isholiday: de.is_holiday,
                  cellstyle:
                    row.status === 'P' || row.status === 'PH'
                      ? 'green'
                      : de.day === 'Sun'
                        ? 'darkred'
                        : de.is_holiday || row.status === 'AB'
                          ? 'red'
                          : row.status === 'LT' ||
                        row.status === 'LO' ||
                        row.status === 'LE'
                            ? 'yellow'
                            : '',
                })
              }),
            }
            rc++
            // console.log(row)
            return row
          })
          console.log('staffattendance', this.staffattendance)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  methods: {
    formatNumber: function (val) {
      return val < 10 ? '0' + val : val
    },
  },
}
</script>

<style>
.at-table {
  width: 100%;
}
.at-h-mid {
  text-align: center;
}
.at-table tbody td {
  border: 1px solid #aaa;
  background: #fff;
  padding: 5px;
  color: #444;
}
.at {
  text-align: center;
}
.at-table th {
  padding: 5px;
}
.at-date-hd {
  background: #e4e4e9;
}
.at-table-hdr {
  background: #bebefd;
}
.at-cell {
  font-size: 90%;
  font-weight: bold;
}
</style>
